import React from 'react';

const SomethingWentWrongIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      fill="none"
      viewBox="0 0 80 80"
    >
      <g clipPath="url(#clip0_2002_26953)">
        <circle
          r="40"
          fill="#2D81F7"
          opacity="0.2"
          transform="matrix(-1 0 0 1 40.003 40)"
        />
        <path
          fill="#2D81F7"
          fillRule="evenodd"
          d="M2.5-97.5c37 0 67 30.217 67 67.5a67.568 67.568 0 01-29.78 56.135l.56.829A68.568 68.568 0 0070.5-30c0-37.828-30.441-68.5-68-68.5s-68 30.672-68 68.5 30.441 68.5 68 68.5a67.36 67.36 0 0026.561-5.423l-.393-.919A66.36 66.36 0 012.5 37.5c-37 0-67-30.217-67-67.5s30-67.5 67-67.5z"
          clipRule="evenodd"
          opacity="0.2"
        />
        <path
          fill="#2D81F7"
          fillRule="evenodd"
          d="M29.639 11.894C10.09 26.33-17.458 22.187-31.895 2.64-40.956-9.632-42.698-25.057-37.9-38.413l-.941-.338C-43.747-25.094-41.968-9.318-32.7 3.233c14.764 19.992 42.94 24.23 62.932 9.466 19.992-14.765 24.23-42.94 9.465-62.932-14.764-19.992-42.94-24.23-62.931-9.466a44.859 44.859 0 00-12.023 13.307l.861.509a43.858 43.858 0 0111.756-13.011C-3.092-73.33 24.458-69.187 38.894-49.64 53.33-30.091 49.186-2.542 29.639 11.894z"
          clipRule="evenodd"
          opacity="0.2"
        />
        <path
          fill="#2D81F7"
          fillRule="evenodd"
          d="M62.497-85.5c37 0 67 30.217 67 67.5s-30 67.5-67 67.5c-16.722 0-32.012-6.171-43.752-16.377l-.656.754C30.003 44.235 45.524 50.5 62.497 50.5c37.559 0 68-30.672 68-68.5s-30.441-68.5-68-68.5-68 30.672-68 68.5c0 19.389 7.997 36.897 20.85 49.359l.696-.718C3.377 18.361-4.503 1.108-4.503-18c0-37.283 30-67.5 67-67.5z"
          clipRule="evenodd"
          opacity="0.2"
        />
        <path
          fill="#FFAF27"
          fillRule="evenodd"
          d="M22.164 40.716c2.476-3.621 7.818-3.621 10.294 0l.979 1.433a172.158 172.158 0 0115.74 28.48l.205.47c1.528 3.513-.781 7.501-4.588 7.927a157.398 157.398 0 01-34.966 0c-3.807-.425-6.116-4.414-4.588-7.927l.205-.47a172.162 172.162 0 0115.74-28.48l.98-1.433z"
          clipRule="evenodd"
        />
        <path
          fill="#F9E4C5"
          d="M25.044 70.769a2.267 2.267 0 114.533 0 2.267 2.267 0 01-4.534 0zM27.31 64.535a1.7 1.7 0 01-1.7-1.7V51.5a1.7 1.7 0 113.4 0v11.335a1.7 1.7 0 01-1.7 1.7z"
        />
        <path
          fill="#E23D5A"
          d="M63.124 56.819C35.387 56.819 34 75.829 34 94.908h60c-.616-16.288-3.139-38.09-30.876-38.09z"
        />
        <ellipse
          cx="62.686"
          cy="57.695"
          fill="#E23D5A"
          rx="12.482"
          ry="4.818"
        />
        <rect
          width="31.095"
          height="25.401"
          x="48.015"
          y="18.717"
          fill="#081A3D"
          rx="6.946"
        />
        <path
          fill="#F9B99E"
          d="M56.748 45.592a6.33 6.33 0 1112.631.088l-.722 9.505a2.436 2.436 0 001.07 2.206c1.214.816 1.04 2.653-.306 3.225l-2.698 1.148a9.95 9.95 0 01-7.659.055l-2.8-1.145c-1.393-.569-1.531-2.486-.235-3.25a2.65 2.65 0 001.301-2.447l-.581-9.385z"
        />
        <mask
          id="mask0_2002_26953"
          style={{ maskType: 'alpha' }}
          width="16"
          height="20"
          x="55"
          y="38"
          maskUnits="userSpaceOnUse"
        >
          <path
            fill="#F9B99E"
            d="M56.75 45.592a6.33 6.33 0 1112.628.088l-.732 9.627a1.657 1.657 0 001.107 1.69c.533.186.4.975-.165.975H56.205c-.573 0-.694-.808-.146-.975a1.817 1.817 0 001.283-1.851l-.593-9.554z"
          />
        </mask>
        <g mask="url(#mask0_2002_26953)">
          <path
            fill="#F49D82"
            d="M56.05 39.476h14.569v1.253c0 7.532-6.17 13.603-13.7 13.48l-.87-14.733z"
          />
        </g>
        <path
          fill="#F9B8A4"
          d="M46.283 34.813a3.192 3.192 0 013.159-3.648h28.24a3.192 3.192 0 013.16 3.648l-.094.646a3.191 3.191 0 01-3.159 2.735H49.535a3.191 3.191 0 01-3.158-2.735l-.094-.646z"
        />
        <path
          fill="#F9B8A4"
          d="M78.806 29.404c0 9.189-3.406 21.912-14.996 21.912-12.432 0-14.995-12.723-14.995-21.912 0-9.19 6.713-16.64 14.995-16.64s14.996 7.45 14.996 16.64z"
        />
        <ellipse cx="57.253" cy="33.511" fill="#081A3D" rx="1.095" ry="1.533" />
        <ellipse cx="69.078" cy="33.511" fill="#081A3D" rx="1.095" ry="1.533" />
        <path
          stroke="#DB8C74"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.81"
          d="M63.213 34.927c-.699 1.724-1.857 5.232-.899 5.475.959.244 2.197.102 2.696 0"
        />
        <rect
          width="5.155"
          height="5.155"
          x="51.599"
          y="36.257"
          fill="#F49D82"
          rx="2.577"
        />
        <rect
          width="5.155"
          height="5.155"
          x="70.371"
          y="36.257"
          fill="#F49D82"
          rx="2.577"
        />
        <path
          fill="#081A3D"
          d="M57.538 23.645c-2.34 3.67-7.325 7.306-9.665 5.814-2.34-1.491-1.147-7.545 1.193-11.215s6.133-5.437 8.473-3.945c2.34 1.49 2.339 5.675-.001 9.346zM79.61 27.736c-.016 3.265-.876 7.572-1.91 7.567-1.035-.005-1.853-4.32-1.837-7.586.016-3.266.868-5.909 1.903-5.904 1.035.005 1.86 2.657 1.844 5.923z"
        />
        <path
          fill="#081A3D"
          d="M51.006 27.734c-.016 3.265-.794 7.572-1.726 7.568-.933-.005-1.668-4.32-1.652-7.585.016-3.266.785-5.91 1.718-5.905.933.005 1.676 2.656 1.66 5.922zM69.642 13.667c5.202 3.344 10.387 10.372 8.313 13.597-2.073 3.225-10.62 1.426-15.821-1.919-5.202-3.344-7.737-8.67-5.664-11.894 2.074-3.225 7.971-3.129 13.172.216z"
        />
        <path
          fill="#081A3D"
          d="M69.193 11.905c5.834 2.052 12.502 7.692 11.23 11.309-1.272 3.617-10.003 3.84-15.836 1.789-5.834-2.052-6.238-5.735-4.966-9.352 1.272-3.617 3.739-5.797 9.572-3.746z"
        />
        <path
          fill="#081A3D"
          d="M62.245 9.507c4.782-1.583 11.797 1.52 12.665 4.144.868 2.623-4.74 3.773-9.521 5.355-4.782 1.582-9.362.739-10.23-1.884-.868-2.623 2.304-6.033 7.086-7.615z"
        />
        <path
          fill="#081A3D"
          d="M53.104 14.166c-3.346 1.063-7.114 4.506-6.315 7.023.8 2.517 5.864 3.156 9.21 2.093 3.345-1.062 5.41-3.964 4.61-6.482-.8-2.517-4.16-3.696-7.505-2.634z"
        />
        <path
          fill="#081A3D"
          d="M58.029 25.277c1.418 1.732 4.346 3.152 5.648 2.085 1.303-1.067.487-4.217-.931-5.949-1.419-1.73-3.624-2.27-4.927-1.202-1.302 1.067-1.209 3.335.21 5.066zM53.972 32.201c-.68-.995 1.098-2.807 3.014-3.676.683-.31 1.435.076 1.749.758.09.197-.034.427-.242.487-1.795.525-4.336 2.702-4.52 2.431z"
        />
        <path
          fill="#4CF"
          d="M73.416 30.19a3.285 3.285 0 106.57 0c0-1.814-2.19-9.416-3.285-9.416-.657 0-3.285 7.602-3.285 9.416z"
        />
        <path
          fill="#fff"
          d="M76.44 30.294c-.023.813-.728 1.452-1.574 1.428-.846-.025-1.513-.704-1.49-1.517.024-.813.94-4.058 1.217-4.187.278-.13 1.871 3.463 1.848 4.276z"
          opacity="0.3"
        />
        <path
          fill="#081A3D"
          d="M72.753 32.013c.593-1.05-1.331-2.705-3.313-3.408-.707-.252-1.424.196-1.679.903-.073.203.07.422.282.465 1.833.37 4.548 2.326 4.71 2.04z"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M69.535 45.6a2.19 2.19 0 01-2.777 1.372.712.712 0 00-.63.1 1.638 1.638 0 01-2.497-1.863c.426-1.258 2.156-2.25 3.466-2.47a2.19 2.19 0 012.437 2.863z"
          clipRule="evenodd"
        />
        <rect
          width="0.876"
          height="34.599"
          x="71.664"
          y="58.133"
          fill="#C81B3A"
          rx="0.438"
        />
        <rect
          width="0.876"
          height="34.599"
          x="52.832"
          y="58.133"
          fill="#C81B3A"
          rx="0.438"
        />
      </g>
      <defs>
        <clipPath id="clip0_2002_26953">
          <rect width="80" height="80" fill="#fff" rx="10" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SomethingWentWrongIcon;
